import React from 'react';
import { Link } from 'react-router-dom';
import './JobCard.css';

const JobCard = ({ 
  variant = 'default', // 'default', 'elevated', 'minimal'
  titleEn, 
  titleJa, 
  description, 
  buttonText = 'Entry',
  buttonLink,
  linkText = 'この職種の魅力',
  linkUrl,
  seniorsUrl,
  seniorsText = 'この職種の先輩を見る',
  image 
}) => {
  return (
    <div className="job-card" data-variant={variant}>
      <div className="job-card-image-wrapper">
        <span className="job-card-label">{titleEn}</span>
        <Link to={linkUrl} className="job-card-image">
          {image ? (
            <img src={image} alt={titleJa} />
          ) : (
            <div className="job-card-placeholder">
              <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.5"/>
                <path d="M4 20c0-4 4-6 8-6s8 2 8 6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
              </svg>
            </div>
          )}
        </Link>
      </div>
      <div className="job-card-content">
        <h3 className="job-card-title">{titleJa}</h3>
        <p className="job-card-desc">
          {description.split('\n').map((line, i) => (
            <React.Fragment key={i}>
              {line}
              {i < description.split('\n').length - 1 && <br />}
            </React.Fragment>
          ))}
        </p>
        {/^https?:\/\//.test(buttonLink || '') ? (
        <a href={buttonLink} target="_blank" rel="noopener noreferrer" className="job-card-button">
          <span>{buttonText}</span>
          <span>
            <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M5.845 2.22a.75.75 0 0 1 1.06 0L9.23 4.543c.41.41.41 1.075 0 1.485L6.905 8.352a.75.75 0 0 1-1.06-1.061l1.25-1.251H.75a.75.75 0 0 1 0-1.5h6.354l-1.26-1.26a.75.75 0 0 1 0-1.06Z"/>
            </svg>
          </span>
        </a>
        ) : (
        <Link to={buttonLink} className="job-card-button">
          <span>{buttonText}</span>
          <span>
            <svg viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill="currentColor" d="M5.845 2.22a.75.75 0 0 1 1.06 0L9.23 4.543c.41.41.41 1.075 0 1.485L6.905 8.352a.75.75 0 0 1-1.06-1.061l1.25-1.251H.75a.75.75 0 0 1 0-1.5h6.354l-1.26-1.26a.75.75 0 0 1 0-1.06Z"/>
            </svg>
          </span>
        </Link>
        )}
        <Link to={linkUrl} className="job-card-link">{linkText}</Link>
        {seniorsUrl && (
          <Link to={seniorsUrl} className="job-card-seniors">{seniorsText}</Link>
        )}
      </div>
    </div>
  );
};

export default JobCard;
